import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CalendarHeader = ({ 
  currentDate, 
  viewMode, 
  onViewModeChange, 
  onNavigate,
  onTodayClick 
}) => {
  const formatHeaderDate = () => {
    const options = { 
      year: 'numeric', 
      month: 'long',
      ...(viewMode === 'day' && { day: 'numeric' })
    };
    return currentDate?.toLocaleDateString('en-US', options);
  };

  return (
    <div className="bg-card border-b border-border p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg">
            <Icon name="Calendar" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-semibold text-foreground">
              Appointment Scheduling
            </h1>
            <p className="text-sm text-muted-foreground mt-1">
              {formatHeaderDate()}
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <div className="flex items-center bg-muted rounded-lg p-1">
            <button
              onClick={() => onNavigate('prev')}
              className="flex items-center justify-center w-10 h-10 rounded-md text-foreground transition-smooth hover:bg-background"
              aria-label="Previous period"
            >
              <Icon name="ChevronLeft" size={20} />
            </button>
            <Button
              variant="ghost"
              size="sm"
              onClick={onTodayClick}
              className="mx-1"
            >
              Today
            </Button>
            <button
              onClick={() => onNavigate('next')}
              className="flex items-center justify-center w-10 h-10 rounded-md text-foreground transition-smooth hover:bg-background"
              aria-label="Next period"
            >
              <Icon name="ChevronRight" size={20} />
            </button>
          </div>

          <div className="flex items-center bg-muted rounded-lg p-1">
            {['day', 'week', 'month']?.map((mode) => (
              <button
                key={mode}
                onClick={() => onViewModeChange(mode)}
                className={`px-4 h-10 rounded-md text-sm font-medium transition-smooth capitalize ${
                  viewMode === mode
                    ? 'bg-primary text-primary-foreground shadow-sm'
                    : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {mode}
              </button>
            ))}
          </div>

          <Button
            variant="default"
            iconName="Plus"
            iconPosition="left"
            onClick={() => {}}
          >
            <span className="hidden sm:inline">New Appointment</span>
            <span className="sm:hidden">New</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;